import clsx from 'clsx';
import type { ReactNode } from 'react';

import { secondaryButtonClass } from '@/shared/ui/formClasses';
import { Popover, PopoverContent, PopoverTrigger } from '@/shared/ui/popover';
import FilterDropdownTrigger from './FilterDropdownTrigger';
import { FILTER_UI_ICONS } from './filterIcons';

type FilterAdvancedMenuProps = {
  filterCount: number;
  onClear: () => void;
  children: ReactNode;
  widthClassName?: string;
};

/** Il pannello dei filtri avanzati; `widthClassName` ne dà la larghezza. */
export default function FilterAdvancedMenu({
  filterCount,
  onClear,
  children,
  widthClassName = 'w-[min(100vw-2rem,320px)]',
}: FilterAdvancedMenuProps) {
  const isActive = filterCount > 0;

  return (
    <Popover>
      <PopoverTrigger asChild>
        <FilterDropdownTrigger
          label="Filtri avanzati"
          icon={FILTER_UI_ICONS.sliders}
          count={filterCount}
          active={isActive}
          className="shrink-0"
        />
      </PopoverTrigger>

      <PopoverContent
        aria-label="Filtri avanzati"
        align="end"
        className={clsx('grid gap-3 p-3', widthClassName)}
      >
        {children}

        {isActive ? (
          <button type="button" onClick={onClear} className={secondaryButtonClass}>
            Azzera filtri avanzati
          </button>
        ) : null}
      </PopoverContent>
    </Popover>
  );
}
